module.exports = __webpack_public_path__ + "static/media/omena.535e93d6.jpeg";